import { createAsyncThunk } from '@reduxjs/toolkit';
import { OpenInfoApi } from '../http';
import { IOpenInfoQuery } from '../models';

const openInfoApi = new OpenInfoApi();

export const fetchOpenInfoCatalog = createAsyncThunk(
  'openInfo/catalog',
  async (body: IOpenInfoQuery, { rejectWithValue }) => {
    const payload: any = body;
    payload.offset = (Number(body.page) - 1) * Number(body.limit);
    delete payload.page;
    try {
      const data = await openInfoApi.findAll(body);
      return { data, page: 1, limit: 9999, total: data.length };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
